import firebase from '../../firebase';

const exportData = (data) => firebase.functions().httpsCallable('rides-requestExport')(data);

export default exportData;
